<template>

<!-- Modal -->
<div class="modal" id="modalBulkUpdateCollection" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div style="background-color:cornflowerblue" class="modal-header">
        <h4 class="modal-title" id="staticBackdropLabel">
            <i  class="fas fa-edit mr-2" aria-hidden="true"></i>
           <strong> MODIFICA COLLEZIONE DOCUMENTI </strong></h4>
        <button @click="$emit('close')" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form id="formMain" v-on:submit.prevent="submit()" >
                                
                <div class="form-group">                
                    <collectionSelect v-if="refresh" v-bind:props="collection" @update="setCollectionId"></collectionSelect>                
                    <collectionOptionType v-if="refresh" v-bind:typeId="collection.typeId" @update="setCollectionTypeId"></collectionOptionType>  
                </div>
                
                
                <alert-box class="mt-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>   
            <button type="submit"  class="btn btn-primary float-right mt-2 mb-2">
              <i class="fas fa-edit mr-2" aria-hidden="true"></i>
              MODIFICA
            <span v-if="spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>       
      </form>

      
      </div>
      
      
      <div v-if="1==0" class="modal-footer">
       
         
        
           <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Chiudi</button>-->
        
      </div>
    </div>
  </div>
</div>


</template>
<script>

import api                     from '@/api';
import alertBox                from '@/components/common/AlertBox.vue';
import collectionSelect        from '@/components/common/CollectionSelect_1.vue' 
import collectionOptionType    from '@/components/backOffice/CollectionOptionType.vue' 

export default {
  
  components: {alertBox,collectionSelect,collectionOptionType
    
  },  
  props: ['items'],
 
 data () {
    return {
      


      collection           : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        typeId        : 1

      },


      doc             : {},
      alert           : false,
      spinner         : false,
      refresh         : true,
      
      
     
      msg             : {
          
         title : '',
         body  : '',
         type  : 0
      }
      
      

    }
  },

computed: 
  {
   
   
  },
mounted()
{   
    this.$nextTick(()  => {                  
    $('#modalBulkUpdateCollection').modal('show')
        
        console.log(this.items)    
        
    })  
   
},
created()
{ 

  

    
},

methods: 
{
    setCollectionId(collectionId)
    {
      this.collectionId = collectionId
    },
    setCollectionTypeId(Id)
    {
      this.collection.typeId = Id
    },
    
    
    
    
   
        
  async submit() 
  {
    const items = []
    this.items.forEach(item => {
        items.push({"stockMovementId" : item.stockMovementId})
    });
    this.msg.title = ''
    this.spinner = true
    const data  = {'items':items,'collectionId':this.collectionId,'typeId':this.collection.typeId}       
    const sp    = {'sp':'spUpdateBulkStockMovementCollection'}
    const json  = Object.assign(data, sp);
    console.log(json)
    await api.post(json).then(res => {
          
          if(res.status == 200)
            {
                this.msg.title = 'COLLEZIONE DOCUMENTI MODIFICATA.'
                this.msg.body = ''
                this.msg.type = 0
                console.log('UPDATE COLLECTION')
              
            }
           else if(res.status==500)
           {
                          
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1                
                    
           } 
           else
            {
                           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1 
            } 
          
          }).catch(err => {
                           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1 
              
          }).finally(() => {
          this.spinner = false
        });



	}
  
      
}
    
}    
</script>

<style scoped>

 .form-check-label
 {
  cursor: pointer;
 }
.bold {
  font-weight: bolder;
}

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}


</style>